import React from "react";

import { HubTableHeader, InputLabel } from "../../components";

const required = true;

const headCells = [
  {
    id: "status",
    label: "Status",
  },
  {
    id: "lineNumber",
    label: "Line ID",
    required,
  },
  {
    id: "line",
    label: "Line #",
    required,
  },
  {
    id: "part",
    label: "Part",
    required,
  },
  {
    id: "qty",
    label: "Qty",
    required,
  },
  {
    id: "partPrice",
    label: "Part Price",
    required,
  },
  {
    id: "dueDate",
    label: "Customer Due Date",
    required,
  },
  {
    id: "shipDate",
    label: "Final Ship Date",
    required,
  },
  {
    id: "location",
    label: "Foundry",
    required,
  },
];

export const OrderLineItemsHeaderV2 = () => {
  const ITEMS = headCells.map((cell) => ({
    id: cell.id,
    label: cell?.required ? (
      <InputLabel label={cell.label} required disableMargin />
    ) : (
      cell.label
    ),
  }));
  return (
    <HubTableHeader
      items={ITEMS}
      // includeCheckbox={false}
      sx={{ backgroundColor: "hubColors.greyLighter" }}
    />
  );
};

export default OrderLineItemsHeaderV2;
